exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emojis span{\r\nfont-size: 22px;\r\ncursor: pointer;\r\n}\r\n\r\n.emojis :hover{\r\n    background-color: (220,220,220,0.5)\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/emoji-picker/emoji-picker.component.css
// module id = ../../../../../src/app/directive/emoji-picker/emoji-picker.component.css
// module chunks = main